module.exports = fox._r("images/events/new_year/snow_content.png", __webpack_public_path__ + "_/_/_/common/frame/images/events/new_year/snow_content.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/events/new_year/snow_content.png
// module id = 107
// module chunks = 2